import { swoopAssistantGetters } from '@/store/modules/swoopAssistant/routines'

export default {
  [swoopAssistantGetters.SWOOP_ASSISTANT]: state => state.swoopAssistant
}
